import * as types from './mutation-types'
import { hasValue, needToSkip } from '../../../utils'
import { get, isEqual, isUndefined } from 'lodash'
import { resolveFieldExpression, getFormattedDropdownValue } from './helpers'
import { FIELD_PROPS, FIELD_TYPES, MAIN_FORM_NAME } from '../../../consts'
import { hamburgerActions } from '../../mixins/hamburger-module'
import { localStoreActions } from '../../mixins/local-store-module'
import { paginationActions } from '../../mixins/pagination-module'

export default {
  ...hamburgerActions,
  ...localStoreActions,
  ...paginationActions,
  prepareListStore({ commit }, { uId, isSqlChosen }) {
    commit(types.PREPARE_LIST_STORE, { uId, isSqlChosen })
  },
  resetLimitation({ commit }) {
    commit(types.RESET_LIMITATION)
  },
  setAggregateColumn({ commit }, { aggregateColumn }) {
    commit(types.SET_AGGREGATE_COLUMN, { aggregateColumn })
  },
  setAggregateRow({ commit }, { aggregateRow }) {
    commit(types.SET_AGGREGATE_ROW, { aggregateRow })
  },
  setAggregations({ commit }, { aggregations }) {
    commit(types.SET_AGGREGATIONS, { aggregations })
  },
  setAvailableInDetailView({ commit }, { availableInDetailView }) {
    commit(types.SET_AVAILABLE_IN_DETAIL_VIEW, { availableInDetailView })
  },
  setAvailableInList({ commit }, { availableInList }) {
    commit(types.SET_AVAILABLE_IN_LIST, { availableInList })
  },
  setConfirmOption({ commit }, { option, value }) {
    commit(types.SET_CONFIRM_OPTION, { option, value })
  },
  setCollapsedButtons({ commit }, { collapsedButtons }) {
    commit(types.SET_COLLAPSED_BUTTONS, { collapsedButtons })
  },
  setColumn({ commit }, { index, column }) {
    commit(types.SET_COLUMN, { index, column })
  },
  setColumns({ commit }, { columns }) {
    commit(types.SET_COLUMNS, { columns })
  },
  setCurrentParameters({ commit }, { currentParameters }) {
    commit(types.SET_CURRENT_PARAMETERS, { currentParameters })
  },
  setDefaultShowInList({ commit }, { showInList }) {
    commit(types.SET_DEFAULT_SHOW_IN_LIST, { showInList })
  },
  setExpandedRows({ commit }, { rows }) {
    commit(types.SET_EXPANDED_ROWS, { rows })
  },
  setExtendedOptions({ commit }, { options }) {
    commit(types.SET_EXTENDED_OPTIONS, { options })
  },
  setFetchingListData({ commit }, { fetchingListData }) {
    commit(types.SET_FETCHING_LIST_DATA, { fetchingListData })
  },
  setFilter({ commit }, { data, filter }) {
    commit(types.SET_FILTER, { data, filter })
  },
  setGroupActionsRunning({ commit }, { groupActionsRunning }) {
    commit(types.SET_GROUP_ACTIONS_RUNNING, { groupActionsRunning })
  },
  setHiddenSearch({ commit }, filter) {
    commit(types.SET_HIDDEN_SEARCH, filter)
  },
  setLimitation({ commit }, { limit }) {
    if (!limit) return
    commit(types.SET_LIMITATION, { limit })
  },
  setListData({ commit }, { listData }) {
    commit(types.SET_LIST_DATA, { listData })
  },
  setListProperties({ commit }, { value }) {
    commit(types.SET_LIST_PROPERTIES, { value })
  },
  setListProps({ commit }, { props }) {
    commit(types.SET_LIST_PROPS, { props })
  },
  setListVisibilityOptions({ commit }, { options }) {
    commit(types.SET_LIST_VISIBILITY_OPTIONS, { options })
  },
  setMongoList({ commit }, { mongoList }) {
    commit(types.SET_MONGO_LIST, { mongoList })
  },
  setOrder({ commit }, { column, value }) {
    commit(types.SET_ORDER, { column, value })
  },
  setSearchBarCollapsed({ commit }, { value }) {
    commit(types.SET_SEARCH_BAR_COLLAPSED, { value })
  },
  setPrimaryKey({ commit }, { primaryKey }) {
    commit(types.SET_PRIMARY_KEY, { primaryKey })
  },
  setProcessActionsButtons({ commit }, { processActionsButtons }) {
    commit(types.SET_PROCESS_ACTIONS_BUTTONS, { processActionsButtons })
  },
  setRecordsFiltered({ commit }, { recordsFiltered }) {
    commit(types.SET_RECORDS_FILTERED, { recordsFiltered })
  },
  setRecordsTotal({ commit }, { recordsTotal }) {
    commit(types.SET_RECORDS_TOTAL, { recordsTotal })
  },
  setRowClasses({ commit }, { rowClasses }) {
    commit(types.SET_ROW_CLASSES, { rowClasses })
  },
  setRowDetails({ commit }, { index, value }) {
    commit(types.SET_ROW_DETAILS, { index, value })
  },
  setRowStyles({ commit }, { rowStyles }) {
    commit(types.SET_ROW_STYLES, { rowStyles })
  },
  setColumnClasses({ commit }, { columnClasses }) {
    commit(types.SET_COLUMN_CLASSES, { columnClasses })
  },
  setColumnStyles({ commit }, { columnStyles }) {
    commit(types.SET_COLUMN_STYLES, { columnStyles })
  },
  setCellClasses({ commit }, { cellClasses }) {
    commit(types.SET_CELL_CLASSES, { cellClasses })
  },
  setCellStyles({ commit }, { cellStyles }) {
    commit(types.SET_CELL_STYLES, { cellStyles })
  },
  setSearchParams({ commit }, { params }) {
    commit(types.SET_SEARCH_PARAMS, { params })
  },
  setSelectedGroupAction({ commit }, { processId }) {
    commit(types.SET_SELECTED_GROUP_ACTION, { processId })
  },
  setSelectedQueueAction({ commit }, { processId }) {
    commit(types.SET_SELECTED_QUEUE_ACTION, { processId })
  },
  setSelectedRow({ commit }, { value }) {
    commit(types.SET_SELECTED_ROW, { value })
  },
  setSelectedRows({ commit }, { value }) {
    commit(types.SET_SELECTED_ROWS, { value })
  },
  setShowInList({ commit }, { showInList }) {
    commit(types.SET_SHOW_IN_LIST, { showInList })
  },
  setSqlChosenButtonProps({ commit }, { props }) {
    commit(types.SET_SQL_CHOSEN_BUTTON_PROPS, { props })
  },
  setStorageKey({ commit }, { value }) {
    commit(types.SET_STORAGE_KEY, { value })
  },
  setUniversalFilter({ commit }, { value }) {
    commit(types.SET_UNIVERSAL_FILTER, { value })
  },
  setViewMode({ commit }, { mode }) {
    commit(types.SET_VIEW_MODE, { mode })
  },
  setVisibility({ commit }, { key, value }) {
    commit(types.SET_VISIBILITY, { key, value })
  },
  toggleList({ commit }, { visibility }) {
    commit(types.TOGGLE_LIST, { visibility })
  },
  setExpressionChain({ commit }, { expressionChain }) {
    commit(types.SET_EXPRESSION_CHAIN, { expressionChain })
  },
  setFieldPropertiesMap({ commit }, { fieldPropertiesMap }) {
    commit(types.SET_FIELD_PROPERTIES_MAP, { fieldPropertiesMap })
  },
  async updatePropByName(
    { commit, state, dispatch, getters },
    { name, prop = 'value', value, options = [], byExpression, namespace }
  ) {
    const field = get(state, ['fieldPropertiesMap', name])

    if ((field && isEqual(field[prop], value)) || !field) return

    if (field.type === FIELD_TYPES.NUMBER && prop === FIELD_PROPS.VALUE) {
      value = Number(value)
    }

    commit(types.UPDATE_PROP_BY_NAME, {
      name,
      prop,
      value,
      byExpression,
    })

    if (FIELD_TYPES.DROPDOWN === field.type && prop === FIELD_PROPS.VALUE) {
      let formattedValue = ''
      if (hasValue(value)) {
        switch (field.type) {
          case FIELD_TYPES.DROPDOWN:
            const contextData = getters.getListExpressionContextData(name)
            const idForm = getters.mongoId
            const fieldId = field.id
            formattedValue = await getFormattedDropdownValue({ options, value, idForm, contextData, fieldId })
            break
          default:
            break
        }
      }
      commit(types.UPDATE_PROP_BY_NAME, {
        name,
        prop: FIELD_PROPS.FORMATTED_VALUE,
        value: formattedValue,
        byExpression,
      })
    }

    if (byExpression) return
    dispatch('triggerExpressionResolver', { field, prop, namespace })
  },
  setIsSavable({ commit }, { isSavable }) {
    commit(types.SET_IS_SAVABLE, { isSavable })
  },
  setFieldPathMap({ commit }, { fieldPathMap }) {
    commit(types.SET_FIELD_PATH_MAP, { fieldPathMap })
  },
  async triggerExpressionResolver({ state, dispatch, commit, getters }, { field, prop, namespace }) {
    const fieldName = field.name
    const chain = get(state, ['expressionChain', MAIN_FORM_NAME, fieldName], [])
    const isCreate = /create$/.test(get(window, 'CORE.requestRoute', '')) // @regex string vegen 'create'-re true
    const fieldsToSkip = get(state, 'fieldsToSkip', [])

    for (const change of chain) {
      if (needToSkip({ isCreate, change, prop, fieldsToSkip })) continue
      const name = change.changes || change.fieldName
      const field = get(state, ['fieldPropertiesMap', name])
      commit(types.SET_TRIGGER_NAME, { fieldId: field.id, triggerName: fieldName })
      const expression = change.expression
      const prop = change.propToChange
      const value = await resolveFieldExpression({
        expression,
        namespace,
        triggerName: fieldName,
        field,
        prop,
        getters,
        name,
      })

      if (isUndefined(value)) continue

      await dispatch('updatePropByName', {
        name,
        prop,
        value,
        byExpression: true,
      })
    }

    dispatch('setIsSavable', { isSavable: true })
  },
  setSearchTrigger() {},
}
